export const ACCOUNT_DETAILS_TABS = Object.freeze({
  details: 'details',
  trades: 'trades',
});

export function buildAccountDetailsTabs(account) {
  return [
    { key: ACCOUNT_DETAILS_TABS.details, label: 'accounts.tabDetails' },
    { key: ACCOUNT_DETAILS_TABS.trades, label: 'accounts.tabTrades' },
  ].filter((tab) => account?.capabilities?.supportsClosedTrades !== false || tab.key !== ACCOUNT_DETAILS_TABS.trades);
}
